import { createQueryKeys } from '@lukemorales/query-key-factory';

/**
 * reuable query keys for MarketSegments for use with useQuery or useMutation
 */
export const queryKeys = createQueryKeys('marketSegments', {
	getMarketSegments: (type: 'Vertical' | 'SubCategory') => ({ type })
});
